var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"id":"card-vessel-report-confirmor","title":"確認者"}},_vm._l((_vm.confirmorList),function(confirmor,index){return _c('div',{key:index,staticClass:"vessel-report-confirmor-list"},[_c('report-confirmor-list-item',{attrs:{"confirmor":confirmor}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }